<template>
  <div class="main-body" :style='"height:"+(th+115)+"px"'>
<!--    <div class="header">政府列表</div>-->
    <div class="out">

      <div class="search2">

        <div style="float: left;">
          <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <div style="height: 0px;"></div>

      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="name" label="公司名称" width="200" fixed></el-table-column>

        <el-table-column prop="tel" label="电话" width="150"></el-table-column>
        <el-table-column prop="contacts" label="联系人" width="100"></el-table-column>

        <el-table-column prop="address" label="地址" width="280"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            <p>{{ scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="listStaffDTO" label="管理员" width="180">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.listStaffDTO" :key="index">
              <div>{{item.loginName}}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="200" label="营业执照">
          <template slot-scope="scope">
            <div v-if="scope.row.certificateImg != null ">
              <el-popover placement="right" trigger="click" >
                <img :src="imgUrl+scope.row.certificateImg" style="width: 500px"/>
                <img slot="reference" :src="imgUrl+scope.row.certificateImg" style="width:60px">
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="auditStatus" label="身份审核" width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.auditStatus == 0">待审核</div>
            <div v-if="scope.row.auditStatus == 1">已审核</div>
            <div v-if="scope.row.auditStatus == 2">被驳回</div>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <div v-if="scope.row.status == 0">默认</div>
            <div v-if="scope.row.status == 1">正常</div>
            <div v-if="scope.row.status == 2">被禁用</div>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>

            <el-button v-if="scope.row.auditStatus == 0 || scope.row.auditStatus == 2" type="text" size="mini" @click="handleDeal(scope.$index, scope.row)">审核</el-button>
            <el-button v-else type="text" size="mini" disabled>审核</el-button>

            <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>

            <el-button v-if="scope.row.isChain == 1 && scope.row.chainType == 'parent'" type="text" size="medium"
                       @click="handleEditSon(scope.$index, scope.row)">编辑分机构</el-button>

          </template>
        </el-table-column>

      </el-table>

      <div class="page" >
        <div style="float: left;">共{{ totalItems }}条（{{ Math.ceil(totalItems / pageSize) }}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="pageSize"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-bind:roleValue="roleValue"
         v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-bind:roleValue="roleValue"
          v-on:getList="getList"></Edit>
    <Deal ref="myDeal" v-show="showModalDeal" v-on:closeDeal="closeDeal" v-bind:roleValue="roleValue"
          v-on:getList="getList"></Deal>

    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="20" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>


    <EditSon ref="myEditSon" v-show="showModalEditSon" v-on:closeEditSon="closeEditSon"
             v-on:getList="getList"></EditSon>

  </div>
</template>

<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

import Edit from "./Edit";
import Add from "./Add";
import Deal from "./Deal";

import EditSon from "./EditSon";

export default {
  name: "Page",

  activated() {

    let topTabs = this.$store.state.topTabs;
    if(topTabs && topTabs.length>0){
      let path = this.$route.path;
      let index = topTabs.findIndex(item => item === path);
      if(index ==-1){
        console.log("JobClass 需要重加载");
        //this.init();
      }
    }
    else{
      console.log("JobClass 需要重加载");
      //this.init();
    }


    let topTabs1 = this.$store.state.topTabs;
    if(topTabs1 == null){
      topTabs1 = [];
      topTabs1.push(this.$route.path);
      this.$store.commit('update', ['topTabs',topTabs1]);
    }
    else{
      let index = topTabs.findIndex(item => item === this.$route.path);
      if(index ==-1){
        topTabs1.push(this.$route.path);
        this.$store.commit('update', ['topTabs',topTabs1]);
      }
    }


  },
  deactivated() {
    //console.log("JobClass停用");
  },


  components: {Add, Edit,Deal, EditSon},

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data() {
    return {
      loading: false,

      showModalAdd: false,
      showModalEdit: false,
      showModalDeal: false,
      showModalEditSon: false,

      batchDialog: false,
      governmentCode:'',
      password:'',

      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      roleValue: [],

      th: 0,

      imgUrl: this.$imgUrl,

    }
  },

  created() {
    this.getList();
    //this.init();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      console.log(val);
      this.th = val;
    },
  },
  methods: {
    init() {

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Role/ListGovRole",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              console.log(response.data.data)
              var roleValue = response.data.data;
              roleValue = this.remove(roleValue, '商家')
              roleValue = this.remove(roleValue, '医院管理员')
              roleValue = this.remove(roleValue, '系统管理员')
              roleValue = this.remove(roleValue, '超级管理员')
              this.roleValue = roleValue
            } else if (response.data.error == 1) {
              this.$message(response.data.message);
            } else {
              console.log(response.data.message);
            }

          }
      )


    },
    remove(array, name) {
      for (var i = 0; i < array.length; i++) {
        if (array[i].name == name) {
          array.splice(i, 1);
          return array
        }

      }
    },


    toggleModalAdd: function () {
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    handleDeal(index, row) {
      this.$refs.myDeal.init(row);
      this.showModalDeal = !this.showModalDeal;
    },
    closeDeal: function () {
      this.showModalDeal = !this.showModalDeal;
    },

    handlePassword(index, rows) {
      this.batchDialog = true;
      this.governmentCode = rows.governmentCode
    },
    editPassword() {

      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'Government/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode: this.governmentCode,
          password: this.password,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.batchDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    handleEditSon(index, row) {
      this.$refs.myEditSon.init(row);
      this.showModalEditSon = !this.showModalEditSon;
    },
    closeEditSon: function () {
      this.showModalEditSon = !this.showModalEditSon;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    getList() {
      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Government/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

